import { Check, X, Plane } from "lucide-react";

export const PendingInvites = ({ P }) => {
  if (!P.invites.length) return null;
  return (
    <div className="space-y-2 mb-4" data-testid="pending-invites">
      {P.invites.map((p) => {
        const host = p.members.find((m) => m.user_id === p.owner_id) || p.members[0];
        return (
          <div key={p.id} className="rounded-xl border border-sky-400/40 bg-sky-400/10 p-3 animate-pop" data-testid={`invite-${p.id}`}>
            <p className="text-sm flex items-center gap-2"><Plane size={14} className="text-sky-300" /><span><b>{host.name.split(" ")[0]}</b> invited you to plan a trip to <b>{p.country}</b></span></p>
            <div className="flex gap-2 mt-2 pl-6">
              <button onClick={() => P.respond(p, true)} className="flex items-center gap-1 text-xs px-3 py-1 rounded-full bg-sky-400 text-[#06121c] hover:bg-sky-300 transition-colors" data-testid={`invite-accept-${p.id}`}><Check size={12} /> Join trip</button>
              <button onClick={() => P.respond(p, false)} className="flex items-center gap-1 text-xs px-3 py-1 rounded-full border border-white/15 text-slate-300 hover:text-white transition-colors" data-testid={`invite-decline-${p.id}`}><X size={12} /> Decline</button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
